import React from 'react'
import styled from 'styled-components'
import Text from 'components/_UI/Text'
import { ChevronUp, ChevronDown, Edit, Trash2, ImageOff } from 'lucide-react'
import colors from 'theme/colors'

export default function SponsorItemCard({ item, canMoveUp, canMoveDown, onMoveUp, onMoveDown, onEdit, onDelete }) {
    return (
        <Card>
            <Logo>
                {item?.logo_url ? (
                    <LogoImage src={item.logo_url} alt={item.name} />
                ) : (
                    <ImageOff size={18} color={colors.nightLight} />
                )}
            </Logo>

            <Text paddingBottom={0} name='small' type='bold' color={colors.nightDark}>
                {item?.name}
            </Text>

            <Actions>
                <IconButton disabled={!canMoveUp} onClick={() => canMoveUp && onMoveUp()}>
                    <ChevronUp size={16} color={canMoveUp ? colors.night : colors.nightLight} />
                </IconButton>
                <IconButton disabled={!canMoveDown} onClick={() => canMoveDown && onMoveDown()}>
                    <ChevronDown size={16} color={canMoveDown ? colors.night : colors.nightLight} />
                </IconButton>
                <IconButton onClick={onEdit}>
                    <Edit size={16} color={colors.primaryLight} />
                </IconButton>
                <IconButton onClick={onDelete}>
                    <Trash2 size={16} color={colors.danger} />
                </IconButton>
            </Actions>
        </Card>
    )
}

const Card = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid ${colors.night}11;
    background: ${colors.neutralLight};
`;

const Logo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 6px;
    background: ${colors.neutralDark}88;
    overflow: hidden;
`;

const LogoImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
`;

const IconButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
    opacity: ${({ disabled }) => disabled ? 0.4 : 1};

    &:hover:not(:disabled) {
        background: ${colors.neutralDark};
    }
`;
